export interface Devices {
  id: string;
  assigned_date: Date;
  device_id: string;
  name: string;
  purchase_date: Date;
  status: string;
  update_time: Date;
  user_info?: {
    name: string;
    phone: string;
    email: string;
    profile_picture: string;
  };
  warranty_date: Date;
}

export interface DeviceTableProps {
  devices: Devices[];
  onEdit: (deviceId: string) => void;
  onDelete: (deviceId: string) => void;
}

/**
 * EV-323。削除の確認の「状態」の欄。一覧（DeviceTable の t('status.<値>')）と同じ既存の文言で出す。
 * 以前は英語の固定の文字（Available・Damaged・In Repair）を返し、日本語でも英語のまま出ていた。
 * 使用中は利用者の名前。名前が空・状態が空・知らない値は「-」（EV-311 の表の空と同じ）。
 * EV-342。使用中かは一覧と同じく status だけで決める（以前は `|| data.user` も見ており、使用中でないのに user が
 * 残るデータで、一覧は状態の文言、削除の確認は利用者の名前と表示が分かれた）。
 */
const TRANSLATED_STATUSES = ['available', 'in_repair', 'damaged'];

const deleteStatusValue = (t: any, data: any): string => {
  if (data.status === 'using') return data.user_info?.name || '-';
  return TRANSLATED_STATUSES.includes(data.status) ? t(`status.${data.status}`) : '-';
};

export const addDeviceFields = (
  t: any,
  data: any = {},
  assignUserOption: any[]
) => [
  {
    label: t('add-device.device-id'),
    type: 'text',
    name: 'device_id',
    isRequired: true,
  },
  {
    label: t('add-device.device-name'),
    type: 'text',
    name: 'name',
    isRequired: true,
  },
  {
    label: t('add-device.status'),
    type: 'select',
    name: 'status',
    options: assignUserOption,
    isRequired: false,
  },
  {
    label: t('add-device.purchase'),
    type: 'date',
    name: 'purchase_date',
    isRequired: false,
  },
  {
    label: t('add-device.warranty'),
    type: 'date',
    name: 'warranty_date',
    isRequired: false,
  },
];

export const editDeviceFields = (
  t: any,
  data: any = {},
  assignUserOption: any[]
) => [
  {
    label: t('edit-device.device-id'),
    type: 'text',
    name: 'device_id',
    isRequired: true,
    value: data.device_id,
  },
  {
    label: t('edit-device.device-name'),
    type: 'text',
    name: 'name',
    isRequired: true,
    value: data.name,
  },
  {
    label: t('edit-device.status'),
    type: 'select',
    name: 'status',
    options: assignUserOption,
    isRequired: false,
    value: data.status,
  },
  {
    label: t('edit-device.purchase'),
    type: 'date',
    name: 'purchase_date',
    isRequired: false,
    value: data.purchase_date,
  },
  {
    label: t('edit-device.warranty'),
    type: 'date',
    name: 'warranty_date',
    isRequired: false,
    value: data.warranty_date,
  },
];

export const deleteDeviceFields = (t: any, data: any = {}) => [
  {
    label: t('delete-device.device-id'),
    name: 'device_id',
    value: data.device_id,
  },
  {
    label: t('delete-device.device-name'),
    name: 'device_name',
    value: data.name,
  },
  {
    label: t('delete-device.status'),
    name: 'status',
    value: deleteStatusValue(t, data),
  },
];
